import EmblaCarousel from 'embla-carousel';
import { addPrevNextBtnsClickHandlers } from '../helpers/emblaControls';
const selectors = {
    productCarousel: '[data-product-carousel]',
    productCarouselViewport: '[data-product-carousel-viewport]',
    productCarouselPrev: '[data-product-carousel-prev]',
    productCarouselNext: '[data-product-carousel-next]',
};
const productCarousel = () => {
    const productCarousels = document.querySelectorAll(selectors.productCarousel);
    if (productCarousels) {
        productCarousels.forEach((carousel) => {
            const viewportNode = carousel.querySelector(selectors.productCarouselViewport);
            const prevBtnNode = carousel.querySelector(selectors.productCarouselPrev);
            const nextBtnNode = carousel.querySelector(selectors.productCarouselNext);
            const options = {
                loop: false,
                align: 'start',
            };
            const embla = EmblaCarousel(viewportNode, options);
            const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(embla, prevBtnNode, nextBtnNode);
        });
    }
};
export { productCarousel };
